module.exports = __webpack_public_path__ + "img/truy_xuat.24086df2.jpg";